import { render, staticRenderFns } from "./ModalNotificationUser.vue?vue&type=template&id=5536e094&scoped=true&"
import script from "./ModalNotificationUser.vue?vue&type=script&lang=ts&"
export * from "./ModalNotificationUser.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNotificationUser.vue?vue&type=style&index=0&id=5536e094&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536e094",
  null
  
)

export default component.exports